/* eslint-disable no-plusplus */
const WEIGHTS_FIRST_DIGIT = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHTS_SECOND_DIGIT = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const charToValue = (char: string): number => char.charCodeAt(0) - 48;

const calculateDigit = (base: string, weights: number[]): number => {
  let sum = 0;
  for (let i = 0; i < base.length; i++) {
    sum += charToValue(base.charAt(i)) * weights[i];
  }
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

const validateCnpj = (cnpj?: string): boolean => {
  if (!cnpj) return false;

  const normalized = cnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
  if (normalized.length !== 14) return false;

  const base = normalized.substring(0, 12);
  const dvs = normalized.substring(12);

  if (!/^[0-9A-Z]{12}$/.test(base)) return false;
  if (!/^\d{2}$/.test(dvs)) return false;

  if (/^(.)\1{11}$/.test(base)) return false;

  const firstDigit = calculateDigit(base, WEIGHTS_FIRST_DIGIT);
  if (firstDigit !== parseInt(dvs.charAt(0), 10)) return false;

  const secondDigit = calculateDigit(base + firstDigit, WEIGHTS_SECOND_DIGIT);
  return secondDigit === parseInt(dvs.charAt(1), 10);
};

export default validateCnpj;
